import { Flame, ShoppingCart, Zap } from "lucide-react";
import { img, tl } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function CampaignHero({ products, onOpen }) {
  const { add } = useCart();
  const list = products.filter((p) => p.is_campaign && p.stock > 0);
  const p = list[0];
  if (!p) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 lg:px-6 pt-5" data-testid="campaign-hero">
      <div className="relative overflow-hidden rounded-xl bg-[#172554] text-white grid md:grid-cols-[1.1fr_1fr]">
        <img src="/products/hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-15" />
        <div className="relative p-6 sm:p-10 lg:p-14 flex flex-col justify-center">
          <span className="inline-flex w-fit items-center gap-1.5 bg-[#16A34A] text-xs font-bold uppercase tracking-wider px-3 py-1 rounded">
            <Flame className="h-3.5 w-3.5" /> Günün Kampanyası
          </span>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05]">{p.name}</h1>
          <p className="mt-3 text-base md:text-lg text-blue-100">{p.brand} · {p.weight} · {p.flavor}</p>
          <div className="mt-6 flex items-end gap-3 flex-wrap">
            {p.discount_pct > 0 && <span className="bg-white text-[#15803D] font-extrabold px-2 py-1 rounded text-lg whitespace-nowrap">-%{Math.round(p.discount_pct)}</span>}
            <span className="text-3xl sm:text-4xl font-extrabold whitespace-nowrap" data-testid="campaign-hero-price">{tl(p.sale_price)}</span>
            {p.old_price && <span className="text-blue-200 line-through text-lg whitespace-nowrap">{tl(p.old_price)}</span>}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <button data-testid="campaign-hero-add-button" onClick={() => add(p)}
              className="h-14 px-6 sm:px-8 rounded-md bg-[#16A34A] hover:bg-[#15803D] font-extrabold text-base sm:text-lg whitespace-nowrap flex items-center gap-2 shadow-lg shadow-green-900/30 hover:-translate-y-0.5 transition-[transform,background-color]">
              <Zap className="h-5 w-5" /> Hemen Tıkla, Sepete Ekle
            </button>
            <button data-testid="campaign-hero-detail-button" onClick={() => onOpen(p)}
              className="h-14 px-6 rounded-md border border-white/40 hover:bg-white/10 font-bold flex items-center gap-2 transition-colors">
              <ShoppingCart className="h-5 w-5" /> İncele
            </button>
          </div>
          {list.length > 1 && (
            <div className="mt-8 flex gap-3 overflow-x-auto no-scrollbar">
              {list.slice(1, 5).map((c) => (
                <button key={c.id} onClick={() => onOpen(c)} data-testid={`campaign-mini-${c.id}`}
                  className="flex items-center gap-3 bg-white/10 hover:bg-white/20 rounded-md p-2 pr-4 shrink-0 transition-colors">
                  <img src={img(c.image)} alt="" className="h-12 w-12 object-contain bg-white rounded" />
                  <div className="text-left"><div className="text-xs font-semibold max-w-[140px] truncate">{c.name}</div><div className="text-sm font-extrabold">{tl(c.sale_price)}</div></div>
                </button>
              ))}
            </div>
          )}
        </div>
        <button onClick={() => onOpen(p)} className="relative bg-white m-4 md:m-6 rounded-lg flex items-center justify-center p-4">
          <img src={img(p.image)} alt={p.name} data-testid="campaign-hero-image" className="max-h-[300px] md:max-h-[420px] w-full object-contain hover:scale-105 transition-transform duration-500" />
        </button>
      </div>
    </section>
  );
}
